import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { HiOutlineTrash } from "react-icons/hi";
import { Button } from "@mui/material";
import { TiTick } from "react-icons/ti";
import { validate } from "../../../utils";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import Toast from "../../../Component/DigitalMarketing/Toast";
import { Change } from "../../../store/async-actions/digitalmarketing/header";
import AntSwitch from "../../../Component/DigitalMarketing/AntSwitch";
import {
  useAddRoleManagementMutation,
  useDeleteRoleManagementMutation,
  useGetRoleManagementsQuery,
  useUpdateRoleManagementMutation,
} from "../../../Service/roleManagement";
import dele from "../../../assets/DigitalMarketing/image/delete.svg";
import AlertDialog from "../../../Component/DigitalMarketing/deleteConfirmation";
import useDeleteBox from "../../../hooks/digitalMarketing/useDeleteBox";
import PermissionCheck from "../../../Component/PermissionCheck";
import Pagination from "../../../Component/DigitalMarketing/Pagination";
function RoleManagement() {
  const data = [
    { name: "Treatments 1" },
    { name: "Treatments 2" },
    { name: "Treatments 3" },
    { name: "Treatments 4" },
  ];
  const [show, setshow] = useState<any>(false);
  const [list, setlist] = useState<any>(data);
  const [submit, setSubmit] = useState(false);
  const [val, setval] = useState<any>("");
  const dispatch = useDispatch<any>();
  const { open, message, openSnackBar, type } = useSnackbar();
  const permission = useSelector((state: any) => state.auth.permission);
  const [pagination, setpagination] = useState(1);

  const pagi = {
    pageNo: pagination,
   
  };
  const { data: RoleManagementsResponse,isLoading, refetch } =
    useGetRoleManagementsQuery(pagi, {
      refetchOnMountOrArgChange: true,
    });
  const [addRoleManagement] = useAddRoleManagementMutation();
  const [deleteRoleManagement] = useDeleteRoleManagementMutation();
  useEffect(() => {
    
  }, [pagination])
  const [updateRoleManagement] = useUpdateRoleManagementMutation();
  const {
    open: open1,
    message: message1,
    openDelete,
    deleteId,
  } = useDeleteBox();

  useEffect(() => {
    const data: any = {
      first: "Roles",
    };
    dispatch(Change(data));
  }, [dispatch]);
  useEffect(() => {
    // console.log("RoleManagementResponse", RoleManagementsResponse);
  }, [RoleManagementsResponse]);

  const Add = async () => {
    setSubmit(true);
    if (val.trim().length !== 0) {
      try {
        const payload = await addRoleManagement({
          roleName: val,
          activeStatus: 1,
        }).unwrap();
        // console.log("fulfilled", payload);
        openSnackBar("Added successfully");
        refetch();
      } catch (error: any) {
        openSnackBar(error.data.error, "error");
        console.error("rejected", error);

      }
      setval("");
      setshow(false);
      setSubmit(false);
    }
  };

  // const Delete = async (id) => {
  //   await deleteRoleManagement(id);
  // };

  const onChange = async (id, event, check = false) => {
    setSubmit(false);
    if (check) {
      try {
        const payload = await updateRoleManagement({
          id,
          [event.target.name]: check
            ? event.target.checked
              ? 1
              : 0
            : event.target.value,
        }).unwrap();
        // console.log("fulfilled", payload);
        openSnackBar("Updated successfully");
      } catch (error: any) {
        openSnackBar(error.data.error, "error");
        console.error("rejected", error);
      }
    } else {
      if (validate(event.target.value)) {
        try {
          const payload = await updateRoleManagement({
            id,
            [event.target.name]: check
              ? event.target.checked
                ? 1
                : 0
              : event.target.value,
          }).unwrap();
          // console.log("fulfilled", payload);
          openSnackBar("Updated successfully");
          refetch();

        } catch (error: any) {
          openSnackBar(error.data.error, "error");
          console.error("rejected", error);
        }
      } else {
        setSubmit(true);
      }
    }
  };
  const Delete = async (bool) => {
    if (bool) {
      try {
       const res =  await deleteRoleManagement(deleteId).unwrap();
        refetch();
        openSnackBar("Deleted successfully");
        refetch();

      } catch (err:any) {
        openSnackBar(err?.data?.error,"error");
      }
    }
    openDelete("Are you sure you want to delete this role?", false, null);
  };

  return (
    <div className="mt-5">
      <Toast open={open} type={type} message={message} />
    <>
        <AlertDialog open={open1} message={message1} deleteBranches={Delete} />
      </>
      {RoleManagementsResponse &&
        RoleManagementsResponse?.data.map((a, i) => {
          return (
            <RenderData
              a={a}
              // onChange={onChange}
              openDelete={openDelete}
              submit={submit}
            />
          );
        })}
      {show ? (
        <div
          className="list-type-input"
          style={{ border: submit && !validate(val) ? "1px solid red" : "" }}
        >
          <input
            type="text"
            placeholder="Super admin"
            className="text-custom-contain add-new"
            value={val}
            onChange={(e) => {
              setval(e.target.value);
              setSubmit(false);
            }}
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                Add();
              }
            }}
          />
                   {/* <TiTick className={val===""?"tick-inactive cursur":"tick cursur"} onClick={Add} /> */}

        </div>
      ) : (
        ""
      )}
      {PermissionCheck("user_management", "add") && (
        <div className="button-contain mt-3 mb-5">
          <Button
            variant="contained"
            id="btn-grey"
            onClick={() => setshow(!show)}
          >
            {show ? "Close" : "+ Add Role"}
          </Button>
          {!isLoading &&<Pagination setpagination={setpagination} pagination={pagination} data={RoleManagementsResponse}/>}

        </div>
      )}
    </div>
  );
}

const RenderData = (props) => {
  const { onChange, a, openDelete, submit } = props;
  const [val, setVal] = useState(a.roleName);
  const [checked, setChecked] = useState(a.activeStatus == 1);
  useEffect(() => {
    setVal(a.roleName);
    setChecked(a.activeStatus == 1);
  }, [a]);
  return (
    <div
      className="list-type mb-2"
      style={{ border: !validate(val) ? "1px solid red" : "" }}
    >
      <input
        type="text"
        placeholder="Role Management"
        className="text-custom-contain add-new"
        name="roleName"
        value={val}
        onBlur={(e) => onChange(a.id, e)}
        onChange={(e) => setVal(e.target.value)}
        style={{cursor:'default'}}
        disabled={true}
      />
      {/* <div className="d-flex align-center">
        {val!="super_admin" &&(
          <>
        <AntSwitch
          disabled={!PermissionCheck("user_management", "update")}
          checked={checked}
          onChange={(e) => {
            setChecked(e.target.checked);
            onChange(a.id, e, true);
          }}
          name="activeStatus"
          inputProps={{ "aria-label": "ant design" }}
        />
        {PermissionCheck("user_management", "delete") && (
          <img
            src={dele}
            alt="delete"
            onClick={() =>
              openDelete(
                "Are you sure you want to delete this role?",
                true,
                a.id
              )
            }
            className="delete-icon cursur mx-2 action-icon"
          />
        )}
        </>)}
      </div> */}
    </div>
  );
};
export default React.memo(RoleManagement);
